import { useQuery } from 'react-query';
import { queryKeys } from '../../../../../RiskToleranceWorkflow/api/queryKeys';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../../../_hooks/useClientId';

export type OrionRiskIntelligenceWorkflowDTO = {
  surveyId: string;
  environment: string;
};

const fetchOrionRiskIntelligenceWorkflow = async (
  clientId: number,
): Promise<OrionRiskIntelligenceWorkflowDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OriRiskTolerance/NewSurvey', {
      clientId,
    }),
  );
};

export const useOrionRiskIntelligenceWorkflowQuery = (enabled = true) => {
  const clientId = useClientId();
  return useQuery(
    queryKeys.orionRiskIntelligenceWorkflow(clientId),

    () => fetchOrionRiskIntelligenceWorkflow(clientId),

    { cacheTime: 0, enabled },
  );
};
